<aside c11n-drawer [isModal]="true" #helpDrawer>
  <h2 class="c11n-text-xl-headline">{{ helpDrawerContent.mainHeader }}</h2>

  <c11n-tabs [hasAnimation]="true" [activeItem]="tabActiveItem">
    <!-- Ownership Tab-->
    <c11n-tab-panel id="ownership" labelText="{{ helpDrawerContent.ownershipTab }}">
      <div class="help-drawer-ownership-primary-content">
        <h3 class="c11n-text-lg-headline">{{ helpDrawerContent.ownershipTabPrimaryHeader }}</h3>
        <p class="c11n-text-sm">{{ helpDrawerContent.ownershipTabPrimaryContent }}</p>
      </div>

      <c11n-accordion-group>
        <c11n-accordion
          *ngFor="let ownershipType of ownershipTabContentTypes"
          [labelText]="ownershipType['ownershipLabelText']"
          [isExpanded]="isOwnershipExpanded(ownershipType['ownerType'])"
        >
          <div accordion-body>
            <app-help-drawer-tab-content
              [tabContent]="ownershipType['ownerTabContent']"
            ></app-help-drawer-tab-content>
          </div>
        </c11n-accordion>
      </c11n-accordion-group>
    </c11n-tab-panel>

    <!-- Asset Tab -->
    <c11n-tab-panel id="asset" labelText="{{ helpDrawerContent.assetTab }}">
      <app-help-drawer-tab-content
        [tabContent]="assetTabContent"
      ></app-help-drawer-tab-content>
    </c11n-tab-panel>

    <!-- Beneficiaries Tab -->
    <c11n-tab-panel *ngIf="showBeneficiariesTab" id="beneficiaries" labelText="Beneficiaries">
      <app-help-drawer-tab-content
        [tabContent]="beneficiariesTabContent"
      ></app-help-drawer-tab-content>
    </c11n-tab-panel>
  </c11n-tabs>
</aside>
